document.addEventListener("DOMContentLoaded", function () {
  let checkInterval;
  let retries = 0;
  const maxRetries = 20;
  let totalPages = 0;

  function createPaginationLinks(totalPages) {
    const head = document.querySelector("head");

    function getCurrentPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return parseInt(urlParams.get("page")) || 1;
    }

    function updatePaginationLinks() {
      const currentPage = getCurrentPage();

      const existingLinks = document.querySelectorAll('link[rel="prev"], link[rel="next"]');
      existingLinks.forEach((link) => link.remove());

      if (currentPage > 1) {
        const prevLink = document.createElement("link");
        prevLink.rel = "prev";
        prevLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${
          currentPage - 1
        }`;
        head.appendChild(prevLink);
      }

      if (currentPage < totalPages) {
        const nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${
          currentPage + 1
        }`;
        head.appendChild(nextLink);
      }
    }

    // first time initialization
    updatePaginationLinks();

    // update on page change
    window.addEventListener("popstate", updatePaginationLinks);

    const originalPushState = history.pushState;
    history.pushState = function (state, title, url) {
      originalPushState.call(history, state, title, url);
      updatePaginationLinks();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (state, title, url) {
      originalReplaceState.call(history, state, title, url);
      updatePaginationLinks();
    };
  }

  checkInterval = setInterval(function () {
    if (SearchSpring.initDone && retries < maxRetries) {
      const showingItemsElement = document.querySelector(".collection-items-number");

      let totalResults = 0;

      if (showingItemsElement) {
        const text = showingItemsElement.textContent.trim();
        const match = text.match(/(\d+)\s*$/);
        if (match) {
          totalResults = parseInt(match[1]);
        }
      }

      const products = document.querySelectorAll("#searchspring-content .product-card");
      const pageSize = products.length;

      if (totalPages === 0 && pageSize > 0) {
        totalPages = Math.ceil(totalResults / pageSize);
      }

      if (totalResults > 0) {
        createPaginationLinks(totalPages);
        clearInterval(checkInterval);
      }
    } else if (retries >= maxRetries) {
      clearInterval(checkInterval);
    }

    retries++;
  }, 500);
});
